<template>
    <router-view></router-view>
</template>

<style lang="scss">
    @import 'styles/app.scss';
</style>
